<template>
    <NuxtLayout name="main" :top="0">
        <ModuleDetail mode="Gene" v-bind="options" :data="data">
            <!-- * 页面模块 -->
            <module-component1
                :origin="data"
                ref="module1"
                @move3="methods.move(module3)"
                @move4="methods.move(module4)"
                @move8="methods.move(module8)"
                @move9="methods.move(module9)" />
            <module-component2 :origin="data" ref="module2" />
            <module-component3 v-if="data.species == 9606" :origin="data" ref="module3" />
            <module-component4 :origin="data" ref="module4" />
            <module-component5 :origin="data" ref="module5" />
            <module-component6 :origin="data" ref="module6" />
            <module-component9 :origin="data" ref="module9" />
            <module-component7 v-if="data.species == 9606" :origin="data" ref="module7" />
            <module-component8 :origin="data" ref="module8" />
        </ModuleDetail>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 公共组件
import ModuleDetail from "../components/container/index.vue";
//* 私有组件
import ModuleComponent1 from "./components/module1/index.vue";
import ModuleComponent2 from "./components/module2/index.vue";
import ModuleComponent3 from "./components/module3/index.vue";
import ModuleComponent4 from "./components/module4/index.vue";
import ModuleComponent5 from "./components/module5/index.vue";
import ModuleComponent6 from "./components/module6/index.vue";
import ModuleComponent7 from "./components/module7/index.vue";
import ModuleComponent8 from "./components/module8/index.vue";
import ModuleComponent9 from "./components/module9/index.vue";

//* 组件属性
import { useComposable } from "./src/composable";

//* 插件
const route = useRoute();

//* 页面数据初始化
const data = await api.server("GeneDetails", "/api/gene", {
    data: { id: route.params.id },
    method: "POST",
});

//* 组合函数
const { nodes, methods, computeds } = useComposable(data.value);
const { options } = computeds;
const { module1, module2, module3, module4, module5, module6, module7, module8, module9 } = nodes;

//* 获取接口数据，初始化模块
onMounted(async () => {
    //* 请求列表
    const requests: Promise<any>[] = [];

    //* 请求注册
    requests.push(methods.register("/api/gene/homologys", module2.value, "POST"));
    requests.push(methods.register("/api/gene/sequence-info", module4.value));
    requests.push(methods.register("/api/gene/protein-interaction", module6.value, "POST"));
    requests.push(methods.register("/api/gene/models", module9.value));
    if (data.value.species == 9606) requests.push(methods.register("/api/related/drugs", module7.value));

    //* 批量请求
    try {
        Promise.all(requests).then(() => {
            nextTick(() => {
                if (route.query.module) {
                    const module = route.query.module as
                        | "module1"
                        | "module2"
                        | "module3"
                        | "module4"
                        | "module5"
                        | "module6"
                        | "module7"
                        | "module8"
                        | "module9";
                    setTimeout(() => methods.move(nodes[module].value), 1000);
                }
            });
        });
    } catch {}
});
</script>
